/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Promotion details with base64-encoded template image data
 * @export
 * @interface CouponPromotionDetails
 */
export interface CouponPromotionDetails {
    /**
     * Value for inventory and accounting reporting
     * @type {number}
     * @memberof CouponPromotionDetails
     */
    valueInCents?: number | null;
    /**
     * SKU for inventory and accounting reporting
     * @type {string}
     * @memberof CouponPromotionDetails
     */
    sku?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CouponPromotionDetails
     */
    ready: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CouponPromotionDetails
     */
    endDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CouponPromotionDetails
     */
    startDate: Date;
    /**
     * 
     * @type {string}
     * @memberof CouponPromotionDetails
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CouponPromotionDetails
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CouponPromotionDetails
     */
    customerId: string;
    /**
     * Base64-encoded template image data
     * @type {string}
     * @memberof CouponPromotionDetails
     */
    templateImage: string;
    /**
     * 
     * @type {Date}
     * @memberof CouponPromotionDetails
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof CouponPromotionDetails
     */
    id: string;
}

/**
 * Check if a given object implements the CouponPromotionDetails interface.
 */
export function instanceOfCouponPromotionDetails(value: object): value is CouponPromotionDetails {
    if (!('ready' in value) || value['ready'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('templateImage' in value) || value['templateImage'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CouponPromotionDetailsFromJSON(json: any): CouponPromotionDetails {
    return CouponPromotionDetailsFromJSONTyped(json, false);
}

export function CouponPromotionDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CouponPromotionDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'valueInCents': json['valueInCents'] == null ? undefined : json['valueInCents'],
        'sku': json['sku'] == null ? undefined : json['sku'],
        'ready': json['ready'],
        'endDate': (new Date(json['endDate'])),
        'startDate': (new Date(json['startDate'])),
        'description': json['description'] == null ? undefined : json['description'],
        'name': json['name'],
        'customerId': json['customerId'],
        'templateImage': json['templateImage'],
        'createdAt': (new Date(json['createdAt'])),
        'id': json['id'],
    };
}

export function CouponPromotionDetailsToJSON(value?: CouponPromotionDetails | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'valueInCents': value['valueInCents'],
        'sku': value['sku'],
        'ready': value['ready'],
        'endDate': ((value['endDate']).toISOString()),
        'startDate': ((value['startDate']).toISOString()),
        'description': value['description'],
        'name': value['name'],
        'customerId': value['customerId'],
        'templateImage': value['templateImage'],
        'createdAt': ((value['createdAt']).toISOString()),
        'id': value['id'],
    };
}

